import { Reveal, ChapterTag } from "./Reveal";

export const Beratung = () => (
    <section id="beratung" data-testid="beratung-section" className="py-24 sm:py-32 lg:py-40 bg-[#EFECE4]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto text-center">
                <Reveal>
                    <ChapterTag number="02" label="Wie ich berate" center />
                    <h2 className="font-serif font-light text-3xl sm:text-5xl tracking-tight text-[#2B2825]">
                        Du stehst im Mittelpunkt.
                    </h2>
                    <p className="mt-8 font-sans text-base sm:text-lg font-light leading-relaxed text-[#59534C]">
                        Mir ist wichtig, dir auf Augenhöhe zu begegnen. Ich möchte dir nicht sagen, wie du dein Leben
                        führen sollst. Stattdessen schauen wir gemeinsam darauf, was dich beschäftigt, was du verändern
                        möchtest und welche Möglichkeiten zu dir passen könnten.
                    </p>
                    <p className="mt-5 font-sans text-base sm:text-lg font-light leading-relaxed text-[#59534C]">
                        Du bestimmst, worüber wir sprechen und in welchem Tempo. Manchmal geht es darum, eine konkrete
                        Lösung zu finden. Manchmal hilft es bereits, Gedanken zu sortieren, eine andere Perspektive zu
                        bekommen oder mit einer neutralen Person offen sprechen zu können.
                    </p>
                    <p className="mt-10 font-serif italic font-light text-2xl sm:text-3xl text-[#7C6E5C]">
                        «Dein Tempo. Deine Themen.»
                    </p>
                </Reveal>
            </div>
        </div>
    </section>
);
